module.exports = __webpack_public_path__ + "img/visa.960951e8.png";